import { useEffect, useState } from "react";

const Lightbox = ({ photos, index, onClose, onPrev, onNext }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft" && photos.length > 1) onPrev();
      if (e.key === "ArrowRight" && photos.length > 1) onNext();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose, onPrev, onNext, photos.length]);

  return (
    <div
      className={`fixed inset-0 z-[200] flex items-center justify-center transition-all duration-300 ${
        visible ? "bg-black/90 backdrop-blur-sm opacity-100" : "bg-transparent opacity-0"
      }`}
      onClick={onClose}
    >
      <button
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        className="absolute top-5 right-5 bg-white/10 hover:bg-white/25 border border-white/20 text-white rounded-full w-10 h-10 flex items-center justify-center transition-all z-10"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-5 h-5">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>

      {photos.length > 1 && (
        <p className="absolute top-5 left-1/2 -translate-x-1/2 text-white/50 text-sm tabular-nums z-10">
          {index + 1} / {photos.length}
        </p>
      )}

      <img
        src={photos[index]}
        alt={`Foto ${index + 1}`}
        onClick={(e) => e.stopPropagation()}
        className="max-w-[90vw] h-[85vh] w-full object-contain rounded-xl shadow-2xl select-none"
        draggable={false}
      />

      {photos.length > 1 && (
        <>
          <button
            onClick={(e) => { e.stopPropagation(); onPrev(); }}
            className="absolute left-5 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/25 border border-white/20 text-white rounded-full w-11 h-11 flex items-center justify-center transition-all"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-5 h-5">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onNext(); }}
            className="absolute right-5 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/25 border border-white/20 text-white rounded-full w-11 h-11 flex items-center justify-center transition-all"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-5 h-5">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        </>
      )}
    </div>
  );
};

export default Lightbox;
